import { InventoryItem, StockLevelStatus } from '../models/inventory.models';

export function formatCurrency(value: number): string {
  return `R${value.toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatDate(value: string): string {
  const [year, month, day] = value.split('-').map(Number);
  return new Intl.DateTimeFormat('en-ZA', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  }).format(new Date(year, month - 1, day));
}

export function stockLevelClass(item: InventoryItem): StockLevelStatus {
  if (item.stockLevel <= item.reorderLevel / 2) {
    return 'critical';
  }
  if (item.stockLevel <= item.reorderLevel) {
    return 'low';
  }
  return 'ok';
}

export function currentTimestamp(): string {
  return new Intl.DateTimeFormat('en-ZA', {
    weekday: 'long',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(new Date());
}
